const toggleNav = () => {
    const toggleButton = document.getElementById('js-toggle-btn');
    const body = document.body;

    if (!toggleButton) return;

    toggleButton.addEventListener('click',()=>{
        body.classList.toggle('body--open-nav');
    });
}
toggleNav();

const setSizeMainVisual = () => {
    const windowHeight = window.innerHeight;

    const topMainVisual = document.querySelector('.full-screen');

    if (!topMainVisual) return;

    topMainVisual.style.height = windowHeight + 'px';
}

if (window.isMobile) {
    setSizeMainVisual();
}

const switchContactForm = () => {
    const selectElem = document.getElementById('contact-type');
    const formItems = document.getElementsByClassName('contact-form-wrap');

    if (!selectElem || !formItems) return;

    selectElem.addEventListener('change', () => {

        for (let i = 0; i < formItems.length; i++){
            formItems[i].style.display = 'none';
        }

        if (!selectElem.value) return;

        const targetForm = document.getElementById('contact-' + selectElem.value);

        targetForm.style.display = 'block';
    })
}
switchContactForm();